import { TUpdateAuctionActionPayload } from '../../../redux/reducers';
import { ISelectedPromotionInfoSchema } from '../../../repositories/monolith-python/entities/SelectedPromotionInfoSchema';

export function mapAuction(selectedPromotionInfo: ISelectedPromotionInfoSchema): TUpdateAuctionActionPayload {
  const { auctionBet, nextBets } = selectedPromotionInfo;

  const previousBets = selectedPromotionInfo.previousBets || [];

  return {
    currentBet: auctionBet,
    nextBets,
    // Бэк присылает предыдущие ставки в порядке убывания, но фронту нужны ставки в порядке возрастания: [...previousBets, currentBet, ...nextBets]
    // Вынести эту логику на сторону бэка бэки отказываются
    previousBets: previousBets.reverse(),
  };
}
